import gql from 'graphql-tag';

export const GET_NATION_BUILDER_CUSTOM_FIELDS = gql`
  query getNationBuilderCustomFields($organizationRevvUid: String) {
    viewer {
      candidate(revvUid: $organizationRevvUid) {
        name
        available_nation_builder_fields {
          custom_donation {
            name
            value
          }
          custom_person {
            name
            value
          }
        }
      }
    }
  }
`;

export const GET_ORGANIZATION_NATION_BUILDER_CUSTOM_FIELDS = gql`
  query getOrganizationNationBuilderCustomFields($organizationRevvUid: String) {
    viewer {
      state_level_organization(revvUid: $organizationRevvUid) {
        name
        available_nation_builder_fields {
          custom_donation {
            name
            value
          }
          custom_person {
            name
            value
          }
        }
      }
    }
  }
`;
